var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0789 10.7786C14.6245 11.8532 13.9137 12.8002 13.0088 13.5367C12.1039 14.2732 11.0323 14.7768 9.88778 15.0034C8.74325 15.2301 7.56063 15.173 6.44328 14.837C5.32594 14.5011 4.30791 13.8965 3.47819 13.0762C2.64848 12.2559 2.03233 11.2449 1.68363 10.1314C1.33493 9.018 1.2643 7.8361 1.47789 6.68906C1.69149 5.54202 2.18282 4.46477 2.90893 3.55148C3.63503 2.6382 4.57381 1.91669 5.64318 1.45003M15.6432 8.00003C15.6432 7.06202 15.4584 6.13319 15.0995 5.26658C14.7405 4.39997 14.2144 3.61255 13.5511 2.94927C12.8878 2.286 12.1004 1.75986 11.2338 1.4009C10.3672 1.04193 9.43834 0.857178 8.50032 0.857178V8.00003H15.6432Z",
    stroke: "#414B5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.bbf84757e51cacb0330e4f237c68d467.svg";
export { ForwardRef as ReactComponent };